import { useAuth } from '../contexts/AuthContext';
import { useDemo } from '../demo/DemoContext';

export const useEffectiveRole = (): string => {
  const { user } = useAuth();
  const { roleOverride } = useDemo();
  return roleOverride || user?.role || 'employee';
};
